export function delay(ms: number, callback: () => void): void {
  setTimeout(callback, ms);
}

export function defer(callback: () => void): void {
  setTimeout(callback, 0);
}
